import { createContext, useState, useContext, useRef } from "react";

const SlideContext = createContext();

export const useSlideContext = () => useContext(SlideContext);

export const SlideContextProvider = ({ children }) => {
  const [activeSlideTitle, setActiveSlideTitle] = useState("");
  const [modifiedSlideTitle, setModifiedSlideTitle] = useState(false);
  const [activeSlideLayout, setActiveSlideLayout] = useState('');
  const [hasPresentationAudio, setHasPresentationAudio] = useState(false);
  const [hasSlideAudio, setHasSlideAudio] = useState(false);

  const toggleGridFunctionRef = useRef(null);
  const modifySlideTitleFunctionRef = useRef(null);

  const registerToggleGridFunction = (fn) => {
    toggleGridFunctionRef.current = fn;
  }

  const registerModifySlideTitle = (fn) => {
    modifySlideTitleFunctionRef.current = fn;
  }

  const triggerToggleGrid = () => {
    if (toggleGridFunctionRef.current) {
      toggleGridFunctionRef.current();
    }
  }

  const triggerModifySlideTitle = (value) => {
    if (modifySlideTitleFunctionRef.current) {
      modifySlideTitleFunctionRef.current(value);
    }
  }

  return (
    <SlideContext.Provider
      value={{
        activeSlideTitle, setActiveSlideTitle,
        modifiedSlideTitle, setModifiedSlideTitle,
        activeSlideLayout, setActiveSlideLayout,
        hasSlideAudio, setHasSlideAudio,
        registerToggleGridFunction,
        triggerToggleGrid,
        registerModifySlideTitle,
        triggerModifySlideTitle
      }}
    >
      {children}
    </SlideContext.Provider>
  );
}